import React, { useState, useEffect } from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import Album from "./Album";
import { IconController } from "../../Scripts/ImgController";
import Ripples from "react-ripples";
import useIsMobile from "../../Scripts/useIsMobile";
import { mobileBottomSheet, mobileOverlay } from "../../Scripts/mobileBottomSheet";
const Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 99px;
  cursor: pointer;
`;
const Popup = styled.div`
  position: absolute;
  top: 90px;
  z-index: 103 !important;

  .modal {
    width: 320px;
    height: 474px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
  }
  .active {
    color: #0061ff;
    border-bottom: 3px solid #0061ff;
  }
  .border-CK {
    border-bottom: 1px solid #e5e7eb;
  }
  .input {
    border: 1px solid#d1d5db;
    border-radius: 8px;
    width: 100%;
    margin-top: 16px;
    height: 36px;
    background: transparent url(${assets.svg.searchIcon}) no-repeat 8px center;
    padding: 10px 4px 10px 32px;
  }
  .checkbox {
    width: 20px;
    height: 20px;
  }
  .result-list::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
  .data-clear {
    border-top: 1px solid #e5e7eb;
    background: white;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
  .checkbox-unchecked {
    width: 20px;
    height: 20px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    cursor: pointer;
  }
  .checkbox-unchecked:hover {
    width: 20px;
    height: 20px;
    border: 1px solid #93c5fd;
    border-radius: 4px;
    background: #dbeafe;
  }
  ${mobileBottomSheet(".modal")}
  @media (max-width: 767px) {
    .modal {
      height: min(474px, 85vh);
    }
    .data-clear {
      border-radius: 0;
    }
  }
`;
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
  ${mobileOverlay}
`;

const CreationSelectDropdown = ({
  albumData,
  width,
  setAlbumFilter,
  setSongFilter,
  newRequest,
  setNewRequest,
  artistChanged,
  setArtistChanged,
  creationQuery,
  setCreationQuery,
  oneRingRulesAll,
  selectedAlbums,
  setSelectedAlbums,
  selectedSongs,
  setSelectedSongs,
}) => {
  const [popup, setPopup] = useState(false);
  const isMobile = useIsMobile();
  const [clearClicked, setClearClicked] = useState(false);
  const handleOpen = () => {
    setPopup(true);
  };
  const sortHandler = () => {
    if (selectedAlbums.length !== 0) {
      setAlbumFilter("filter[album_id]=" + selectedAlbums);
    }
    if (selectedSongs.length !== 0) {
      setSongFilter("filter[song_id]=" + selectedSongs);
    }
    if (selectedAlbums.length !== 0 || selectedSongs.length !== 0) {
      setNewRequest(!newRequest);
    }
    if (selectedAlbums.length === 0 && selectedSongs.length === 0) {
      setSongFilter("");
      setAlbumFilter("");
      setNewRequest(!newRequest);
    }
    setPopup(false);
  };
  const clearHandler = async () => {
    setClearClicked(true);
    setSelectedAlbums([]);
    setAlbumFilter("");
    setSongFilter("");
    setSelectedSongs([]);
  };
  useEffect(() => {
    clearHandler();
    setArtistChanged(false);
  }, [artistChanged]);
  useEffect(() => {
    if (clearClicked) {
      setClearClicked(false);
    }
  }, [clearClicked]);

  const mappedAlbums = albumData.map((album) => (
    <Album
      key={album.id}
      album={album}
      selectedAlbums={selectedAlbums}
      selectedSongs={selectedSongs}
      oneRingRulesAll={oneRingRulesAll}
    />
  ));
  return (
    <>
      <Ripples color="#0061FF40" during={600} className="rounded-2xl w-full">
        <Wrapper style={{ width: isMobile ? "100%" : width + "px" }}>
          <div
            className="flex flex-row justify-center items-center px-3 py-1"
            onClick={() => {
              handleOpen();
            }}
          >
            <div className="flex-1">
              {selectedAlbums.length !== 0 || selectedSongs.length !== 0 ? (
                <span className="font-medium text-xs">
                  {selectedAlbums.length !== 0
                    ? `${selectedAlbums.length} цомог`
                    : ""}
                  {selectedSongs.length !== 0
                    ? ` ${selectedSongs.length} дуу`
                    : ""}
                </span>
              ) : (
                <span className="font-medium text-xs">Бүгд</span>
              )}
            </div>

            <div className="pl-2">
              <IconController
                src={assets.svg.chevronDown}
                className={`transition-transform ${popup ? "rotate-180" : ""}`}
                alt=""
              />
            </div>
          </div>
        </Wrapper>
      </Ripples>
      {popup ? (
        <>
          <Overlay
            onClick={() => {
              setPopup(false);
            }}
          ></Overlay>
          <Popup>
            <div className="modal">
              <div className="flex flex-col h-full pt-4">
                <div className="pb-5 px-4">
                  <input
                    type="search"
                    className="input text-xs"
                    placeholder="Хайх"
                    value={creationQuery}
                    onChange={(e) => {
                      setCreationQuery(e.target.value);
                    }}
                  />
                </div>
                <div
                  className="flex flex-col gap-2  overflow-scroll result-list px-4"
                  style={{ paddingBottom: "74px" }}
                >
                  {clearClicked ? "" : mappedAlbums}
                </div>

                <div className="data-clear">
                  <div className="flex flex-row gap-2 py-4 px-4 items-center justify-end">
                    <Ripples
                      color="#0061FF40"
                      during={600}
                      className="rounded-3xl"
                    >
                      <div
                        className="clear-button"
                        onClick={() => {
                          clearHandler();
                        }}
                      >
                        <span className="text-xs">Цэвэрлэх</span>
                      </div>
                    </Ripples>
                    <Ripples
                      color="#ffffff40"
                      during={600}
                      className="rounded-3xl"
                    >
                      <div
                        className="sort-button"
                        onClick={() => {
                          sortHandler();
                        }}
                      >
                        <span className="text-xs">Ангилах</span>
                      </div>
                    </Ripples>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default CreationSelectDropdown;
